import { MDSBadge, MDSText, MDSToggle } from "@/mds";
import { useTheme } from "@/mds/themes/ThemeContext";
import { StyledContainer, StyledLeftContainer } from "./theme-switcher.style";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";

interface Props {
  onToggle: () => void;
}

export const ThemeSwitcher = observer(function ThemeSwitcher({ onToggle }: Props) {
  const { themeType } = useTheme();
  const { store } = useAppStore();
  const isPaid = store.subscriptions.personalSubscription?.isPaid ?? false;

  return (
    <StyledContainer onClick={onToggle}>
      <StyledLeftContainer>
        <MdsIcon kind={MdsIconKind.Moon} />
        <MDSText>Dark mode</MDSText> {!isPaid && <MDSBadge label="Pro" />}
      </StyledLeftContainer>
      <MDSToggle checked={themeType === "harvest-moon"} onChange={onToggle} />
    </StyledContainer>
  );
});
